import { styled } from 'styletron-react';

const FooterLink = styled('a', {
  fontSize: '15px',
});

export { FooterLink };
